import { useEffect, useState } from 'react';
const useAppEffects = () => {

	useEffect(() => {
		let timeoutId;

		const setVhProperty = () => {
			if (timeoutId) {
				clearTimeout(timeoutId);
			}

			timeoutId = setTimeout(() => {
				// Get the actual viewport height
				const vh = window.innerHeight * 0.01;
				document.documentElement.style.setProperty('--vh', `${vh}px`);

				// Also set a full height variable for mobile
				document.documentElement.style.setProperty('--full-height', `${window.innerHeight}px`);
			}, 100);
		};

		// Set initial value
		setVhProperty();

		// Listen to both resize and orientationchange for mobile
		window.addEventListener('resize', setVhProperty, { passive: true });
		window.addEventListener('orientationchange', setVhProperty, { passive: true });

		// Additional mobile-specific listeners
		window.addEventListener('scroll', setVhProperty, { passive: true });

		return () => {
			window.removeEventListener('resize', setVhProperty);
			window.removeEventListener('orientationchange', setVhProperty);
			window.removeEventListener('scroll', setVhProperty);
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
		};
	}, []);

	useEffect(() => {
		if ('serviceWorker' in navigator) {
			navigator.serviceWorker.register('/sw.js', { scope: '/' })
				.then(registration => {
					console.log('✅ Service Worker registered:', registration);
					registration.update();
					registration.onupdatefound = () => {
						const installingWorker = registration.installing;
						if (installingWorker) {
							installingWorker.onstatechange = () => {
								if (installingWorker.state === 'installed') {
									if (navigator.serviceWorker.controller) {
										console.log('⚠️ New content available. Please refresh.');
									} else {
										console.log('✅ Content cached for offline use.');
									}
								}
							};
						}
					};
				})
				.catch(error => {
					console.error('❌ Service Worker registration failed:', error);
				});
		}
	}, []);


};

export default useAppEffects;
